var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"production"},[_c('ProcessItem',{attrs:{"name":"Production"}},[_c('MiniProcess',{staticClass:"design",style:({
        marginLeft: _vm.createdPosition,
        width: _vm.createdLength,
        minWidth: _vm.createdLength
      }),attrs:{"description":"Yearbook Layout & Design"}}),_c('MiniProcess',{staticClass:"approval",style:({
        width: _vm.approvalLength,
        minWidth: _vm.approvalLength
      }),attrs:{"description":"Proof Approval","is-display-description-under":true}}),_c('MiniProcess',{staticClass:"print-prodction",style:({
        width: _vm.printLength,
        minWidth: _vm.printLength,
        maxWidth: _vm.printLength
      }),attrs:{"description":"Print Production"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }